import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = hash.split('session_id=')[1];
    if (!sessionId) { navigate('/login', { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id: sessionId });
        login(data.token, data.user);
        navigate(data.user.role === 'admin' ? '/admin' : '/events', { replace: true });
      } catch {
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <div className="spin-gold w-10 h-10 mx-auto mb-4" />
        <p className="text-sm text-[#A1A1AA]">Connexion en cours...</p>
      </div>
    </div>
  );
}
